var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningAmberOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00033 4.32666L13.0203 13H2.98033L8.00033 4.32666ZM8.00033 1.66666L0.666992 14.3333H15.3337L8.00033 1.66666Z",
    fill: "#DF2C4F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66699 11H7.33366V12.3333H8.66699V11Z",
    fill: "#DF2C4F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66699 7H7.33366V10.3333H8.66699V7Z",
    fill: "#DF2C4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningAmberOutlined);
export default __webpack_public_path__ + "static/media/WarningAmberOutlined.c68723d82d0fb5eb18a91b2abedf1099.svg";
export { ForwardRef as ReactComponent };